import { track } from '../analytics/datalayer'

/** Menú mobile: botón inyectado en la nav + overlay glass de pantalla
 *  completa. Una sola implementación para todas las páginas. */
const LINKS: [string, string][] = [
  ['Google Ads', './google-ads.html'],
  ['Sitios web', './sitios-web.html'],
  ['Resultados', './resultados.html'],
  ['Contacto', './contacto.html'],
  ['Blog', 'https://jalapenos.cl/blog/'],
]

export function initMenu(): void {
  const nav = document.querySelector('.nav')
  if (!nav) return

  const btn = document.createElement('button')
  btn.type = 'button'
  btn.className = 'nav__menu mono'
  btn.setAttribute('aria-expanded', 'false')
  btn.setAttribute('aria-label', 'Abrir menú')
  btn.textContent = 'MENÚ'
  nav.appendChild(btn)

  const overlay = document.createElement('div')
  overlay.className = 'menu'
  overlay.hidden = true
  overlay.innerHTML = `
    <button type="button" class="menu__close mono" aria-label="Cerrar menú">CERRAR ×</button>
    <nav class="menu__links" aria-label="Menú principal">
      ${LINKS.map(([label, href]) => `<a href="${href}">${label}</a>`).join('')}
    </nav>
    <a class="btn btn--isla menu__cta" href="https://jalapenos.cl/agendar/" data-cta="menu">
      <span>Agenda tu diagnóstico gratuito</span><span class="btn__arr" aria-hidden="true">&#8599;</span>
    </a>
  `
  document.body.appendChild(overlay)

  const setOpen = (open: boolean) => {
    overlay.hidden = !open
    btn.setAttribute('aria-expanded', String(open))
    document.body.style.overflow = open ? 'hidden' : ''
  }
  btn.addEventListener('click', () => {
    setOpen(overlay.hidden)
    if (!overlay.hidden) track({ event: 'cta_click', cta_location: 'menu-open' })
  })
  overlay.querySelector('.menu__close')?.addEventListener('click', () => setOpen(false))
  overlay.querySelectorAll('a').forEach((a) => a.addEventListener('click', () => setOpen(false)))
  addEventListener('keydown', (e) => {
    if (e.key === 'Escape' && !overlay.hidden) setOpen(false)
  })
}
